<template>
  <v-row no-gutters>
    <div style="width: max-content">
      <navigation-drawer />
    </div>
    <div style="padding: 50px 40px; position: relative; width: calc(100% - 240px);">
      <router-view />
    </div>
  </v-row>
</template>

<script>
import navigationDrawer from "./navigationDrawer.vue";
export default {
  components: { navigationDrawer },
};
</script>

<style>
</style>